import { storeToRefs } from 'pinia'
import { useNotificationsStore } from '@/stores/notifications.js'

export function useNotifications() {
  const store = useNotificationsStore()
  const { items, unreadCount, loading, hasMore } = storeToRefs(store)

  return {
    notifications: items,
    unreadCount,
    loading,
    hasMore,
    loadNotifications: (reset = true) => store.loadNotifications(reset),
    loadMore: () => store.loadMore(),
    markAsRead: (id) => store.markAsRead(id),
    markAllAsRead: () => store.markAllAsRead(),
    closeNotification: (id) => store.closeNotification(id)
  }
}
